import { useState } from 'react';
import { toast } from 'react-toastify';

import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';

import { Button, Text } from 'components';
import { Field, Form, Formik } from 'formik';
import { AuthContext } from 'hooks/useAuth';
import { newConferenceService } from 'services/newConference';
import { useContextSelector } from 'use-context-selector';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  serial_in: Yup.string().required('Serial IN não pode estar em branco'),
  imei: Yup.string().when('serial_in', {
    is: (serial_in) => !!serial_in,
    then: Yup.string()
      .length(15, 'O IMEI deve ter 15 caracteres')
      .required('O campo IMEI é obrigatório'),
  }),
});

export const OpenOs = ({ handleBack, line }) => {
  const [expanded, setExpanded] = useState(false);
  const [isPartnumberWithoutImei, setIsPartnumberWithoutImei] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const user = useContextSelector(AuthContext, (context) => context.user);

  console.log(line);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleOpenLote = async (values) => {
    setIsLoading(true);
    try {
      const { data } = await newConferenceService.openOS({
        idMarca: line.idmarca,
        marca: values.brand,
        idModelo: line.idmodelo,
        modelo: values.model,
        idProduto: line.idproduto,
        produto: values.parnumber,
        serial_in: values.serial_in,
        imei: values.imei,
        reclamacao: values.complaint,
        observacao: values.observation,
        idLote: line.Lote,
        idNF: line.idnf,
        idClient: line.idClient,
        idOperacao: line.idOperation,
        idTipoProduto: line.idTipoProduto,
        idTipoAtendimento: line.idTypeService,
        user: user.id,
      });
      toast.success('OS aberta com sucesso!');
      setIsLoading(false);
    } catch (error) {
      toast.error('Erro ao abrir OS');
      console.error(error?.response?.data?.message);
      setIsLoading(false);
    }
  };

  const handleCheckboxChange = (event) => {
    setIsPartnumberWithoutImei(event.target.checked);
  };

  return (
    <>
      <Box mt={2} component={Paper} boxShadow={3} p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6}>
            <Button
              style={{
                backgroundColor: 'transparent',
                color: 'inherit',
                border: 'none',
              }}
              startIcon={<InfoIcon color='primary' />}
              onClick={handleExpandClick}
            >
              Info Adiocinal
            </Button>
            <Collapse in={expanded} timeout='auto' unmountOnExit>
              <Grid item xs={12} lg={12}>
                <Typography variant='h3' style={{ fontSize: '18px', fontWeight: 'bold' }}>
                  Informações do modelo:
                </Typography>
              </Grid>
              <Grid item xs={12} lg={12}>
                <Typography variant='h3' style={{ fontSize: '18px' }}>
                  Tipo Produto: {line.TipoProduto}
                </Typography>
              </Grid>
              <Grid item xs={12} lg={12}>
                <Typography variant='h3' style={{ fontSize: '18px' }}>
                  Descrição: {line.Produto}
                </Typography>
              </Grid>
              <Grid item xs={12} lg={12}>
                <Typography variant='h3' style={{ fontSize: '18px' }}>
                  Cor: {line.cor}
                </Typography>
              </Grid>
              <Grid item xs={12} lg={12}>
                <Typography variant='h3' style={{ fontSize: '18px' }}>
                  Banda: N/A
                </Typography>
              </Grid>
              <Grid item xs={12} lg={12}>
                <Typography variant='h3' style={{ fontSize: '18px' }}>
                  Operadora: N/A
                </Typography>
              </Grid>
            </Collapse>
          </Grid>
        </Grid>
      </Box>
      <Box mt={2} component={Paper} boxShadow={3} p={2}>
        <Formik
          initialValues={{
            brand: line.Marca,
            serial_in: '',
            imei: '',
            model: line.Modelo,
            parnumber: line.Produto,
            complaint: '',
            observation: '',
          }}
          onSubmit={handleOpenLote}
          validationSchema={validationSchema}
        >
          {(props) => (
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isPartnumberWithoutImei}
                          onChange={handleCheckboxChange}
                          color='primary'
                        />
                      }
                      label='Partnumber sem IMEI'
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}></Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <Field
                    size='small'
                    name='brand'
                    label='Marca'
                    component={Text}
                    variant='outlined'
                    type='text'
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <Field
                    size='small'
                    name='serial_in'
                    label='Serian IN'
                    component={Text}
                    variant='outlined'
                    type='text'
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <Field
                    size='small'
                    name='imei'
                    label='IMEI'
                    component={Text}
                    variant='outlined'
                    type='text'
                    fullWidth
                    disabled={isPartnumberWithoutImei}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <Field
                    size='small'
                    name='model'
                    label='Modelo'
                    component={Text}
                    variant='outlined'
                    type='text'
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={12} lg={12}>
                  <Field
                    size='small'
                    name='parnumber'
                    label='Partnumber'
                    component={Text}
                    variant='outlined'
                    type='text'
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={12} lg={12}>
                  <Field
                    size='small'
                    name='complaint'
                    label='Reclamação Cliente'
                    component={Text}
                    variant='outlined'
                    type='text'
                    fullWidth
                    multiline
                    minRows={5}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Field
                    size='small'
                    name='observation'
                    label='Observação'
                    component={Text}
                    variant='outlined'
                    type='text'
                    fullWidth
                    multiline
                    minRows={5}
                  />
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2}></Grid>
                <Grid item xs={4} sm={4} md={4} lg={4}>
                  <Button onClick={() => handleBack()} color='secondary' fullWidth>
                    Voltar
                  </Button>
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4}>
                  <Button type='submit' fullWidth>
                    Gerar OS
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};
